﻿function fixAdOnScroll() {
    let width = $(document).width();
    let isTablet = width <= 976 && width > 768;
    let isMobile = width <= 768;
    if (isTablet || isMobile) {
        let $leaderboard = $(".leaderboard-container");
        if ($(window).scrollTop() > 100) {
            if (!$leaderboard.hasClass('ad-scroll-fix')) {
                $leaderboard.addClass('ad-scroll-fix');
            }
        } else {
            $leaderboard.removeClass('ad-scroll-fix');
        }
    }
}

export function setupStickOnMobile(){
    //$(document).on('load', fixAdOnScroll);
    //$(document).on('resize', fixAdOnScroll);
    $(document).on("scroll", fixAdOnScroll);
}
